const messages: Record<string, string> = {
	'blockedByDevice.headline': 'Použite smartfón',
	'blockedByDevice.paragraph.first': 'Tento odkaz je možné použiť iba na smartfóne.',
	'blockedByDevice.paragraph.second':
		'Tip: Pri otvorení odkazu sa nachádzajte v blízkosti vozidla a majte pripravené potrebné doklady. ',
	'button.continue': 'Pokračovať',
	'button.next': 'Pokračovať',
	'review.button.next': 'Dokončiť',
	'button.photo.take': 'Odfotiť',
	'onboardingStart.headline': 'Dobrý deň, skontrolujte údaje a kliknite na tlačidlo nižšie.',
	'onboardingStart.plateNumber': 'Evidenčné číslo vozidla:',
	'onboardingStart.damageNumber': 'Číslo poistky:',
	'onboardingStart.timeout': 'Obhliadku vozidla vykonajte najneskôr do ',
	'button.start': 'Začať',
	poweredBy: 'Technológiu poskytuje <ce>ControlExpert</ce>, člen skupiny <solvd>Solvd</solvd>',
	'onboarding.headline': 'Ste pripravený začať digitálnu obhliadku?',
	'onboarding.paragraph': 'Pred začatím obhliadky, prosím, dbajte na nasledujúce:',
	'onboarding.documents':
		'Pripravte si kľúče a osvedčenie o evidencii vozidla (technický preukaz).',
	'onboarding.camera': 'Fotky je možné vyhotoviť iba pomocou fotoaparátu vo vašom smartfóne. ',
	'onboarding.internet':
		'Uistite sa, že sa nachádzate na dobre osvetlenom mieste so stabilným internetovým pripojením. ',
	'onboarding.vehicle':
		'Uistite sa, že je vozidlo čisté, prístupné zo všetkých strán a všetky okná sú zatvorené. ',
	'onboarding.terms.before': 'Pred začatím, prosím, potvrďte nasledujúce:',
	'onboarding.terms.url': 'Súhlasím s podmienkami používania',
	'vehicleFrontLeftPerspectiveImage.title': 'Diagonálny pohľad na vozidlo spredu zľava',
	'vehicleFrontLeftPerspectiveImage.description':
		'Odfoťte vozidlo diagonálne spredu zľava tak, aby bolo celé v zábere a evidenčné číslo bolo viditeľné. ',
	'vehicleRearLeftPerspectiveImage.title': 'Diagonálny pohľad na vozidlo zozadu zľava',
	'vehicleRearLeftPerspectiveImage.description':
		'Odfoťte vozidlo diagonálne zozadu zľava tak, aby bolo celé v zábere a evidenčné číslo bolo viditeľné. ',
	'vehicleRearRightPerspectiveImage.title': 'Diagonálny pohľad na vozidlo zozadu sprava',
	'vehicleRearRightPerspectiveImage.description':
		'Odfoťte vozidlo diagonálne zozadu sprava tak, aby bolo celé v zábere a evidenčné číslo bolo viditeľné. ',
	'vehicleFrontRightPerspectiveImage.title': 'Diagonálny pohľad na vozidlo spredu sprava',
	'vehicleFrontRightPerspectiveImage.description':
		'Odfoťte vozidlo diagonálne spredu sprava tak, aby bolo celé v zábere a evidenčné číslo bolo viditeľné. ',
	'windshieldImage.title': 'Čelné sklo',
	'windshieldImage.description':
		'Odfoťte čelné sklo tak, aby bolo celá plocha skla dobre viditeľná. ',
	'vinPicture.title': 'VIN číslo',
	'vinPicture.description':
		'Odfoďte zblízka VIN číslo vozidla tak, aby boli všetky znaky dobre čitateľné',
	'button.hint': 'Kde nájdem VIN číslo?',
	'photo.deleteConfirmation.title': 'Naozaj chcete odstrániť fotografiu?',
	'photo.deleteConfirmation.description':
		'Ak fotografiu odstránite, budete vyzvaní, aby ste zhotovili novú.',
	'photo.deleteConfirmation.cancel': 'Zrušiť',
	'photo.deleteConfirmation.confirm': 'Odstrániť fotografiu',
	'hint.vin.title': 'Možné umiestnenie VIN čísla',
	'hint.vin.description': 'VIN číslo sa zvyčajne nachádza na jednom z týchto 4 miest',
	'hint.vin.location1': 'Na prístrojovej doske, viditeľné cez čelné sklo na strane vodiča. ',
	'hint.vin.location2': 'Na ráme dverí vodiča, v blízkosti zámku. ',
	'hint.vin.location3': 'V motorovom priestore, často na kovovom štítku. ',
	'hint.vin.location4': 'Na prednej časti rámu vozidla (staršie vozidlá).',
	'overallDashboardImage.title': 'Celkový pohľad na palubnú dosku. ',
	'overallDashboardImage.description':
		'Odfoťte celú palubnú dosku tak, aby boli všetky ovládacie prvky dobre viditeľné. ',
	'dashboardMileage.title': 'Najazdené kilometre',
	'vehicleMileage.description': 'Odfoťte stav najazdených kilometrov tak, aby bol dobre čitateľný.',
	'dashboardMileage.paragraph.first': 'Zadajte aktuálny stav kilometrov vozidla',
	'dashboardMileage.placeholder.updated': 'km',
	'review.title': 'Súhrn digitálnej obhliadky',
	'review.paragraph.first':
		'Pred dokončením skontrolujte, či sú všetky údaje správne.<br/><br/>Po kliknutí na Dokončiť skontrolujeme vaše fotky a údaje.',
	'review.stepDescription.questions': 'Údaje o vozidle',
	'review.stepDescription.group.perspectiveImages': 'Celkové fotky vozidla',
	'review.stepDescription.group.additionalImages': 'Doplňujúce fotky',
	'review.stepDescription.vehicleFrontLeftPerspective': 'Diagonálny pohľad na vozidlo spredu zľava',
	'review.stepDescription.vehicleRearLeftPerspective': 'Diagonálny pohľad na vozidlo zozadu zľava',
	'review.stepDescription.vehicleRearRightPerspective':
		'Diagonálny pohľad na vozidlo zozadu sprava',
	'review.stepDescription.vehicleFrontRightPerspective':
		'Diagonálny pohľad na vozidlo spredu sprava',
	'review.stepDescription.windshield': 'Čelné sklo',
	'review.stepDescription.vinPicture': 'VIN číslo',
	'review.stepDescription.overallDashboard': 'Celkový pohľad na palubnú dosku',
	'review.stepDescription.mileage': 'Najazdené kilometre',
	'thanks.headline.first': 'Ďakujeme, fotky ste nám poslali !',
	'thankYou.message': 'Teraz ich skontrolujú naši technici.',
	'feedback.title': 'Prosím, ohodnoťte nás',
	'feedback.message': 'Ako ste boli spokojný s digitálnou obhliadkou? (5 hviezdičiek je najviac)',
	'feedback.helpImprove': 'Komentár',
	'feedback.button.send': 'Odoslať hodnotenie',
	'feedback.error.maxLength': 'Komentár môže obsahovať najviac 500 znakov. ',
	'timeout.headline.first': 'Digitálna obhliadka sa nenašla',
	'timeout.paragraph.first':
		'Platnosť vašej obhliadky vypršala alebo ste použili nesprávny odkaz. ',
	'photoUploading.title': 'Nahrávanie',
	'photoAnalyzing.title': 'Analyzovanie',
	'photoLoading.title': 'Načítavanie',
	'camera.darkWarning':
		'Prostredie je príliš tmavé. Pre lepšiu kvalitu fotky zabezpečte lepšie osvetlenie. ',
	'landscapeModeDetected.title': 'Automatické otáčanie je zapnuté. ',
	'landscapeModeDetected.text':
		'Pre správne používanie fotoaparátu vypnite automatické otáčanie obrazovky vo svojom smartfóne. ',
	'validationContainer.correct': 'V poriadku',
	'button.changeImage': 'Zmeniť fotku',
	'button.acceptImage': 'Potvrdiť fotku',
	'button.acceptMileage': 'Opraviť',
	'button.anotherImage': 'Odfotiť znova',
	'invalidFile.size.title': 'Nesprávna veľkosť fotky',
	'invalidFile.size.description': 'Veľkosť fotky prekračuje maximálny povolený limit',
	'invalidFile.extension.title': 'Nepodporovaný typ súboru',
	'invalidFile.extension.description':
		'Tento typ súboru nie je podporovaný. Podporované typy súborov: .jpg, .jpeg, .jfif, .heic, .heif, .png, .bmp',
	'connectionError.title': 'Chyba pripojenia',
	'connectionError.description': 'Vyskytla sa chyba pripojenia. Nahrajte fotku znova.',
	'missingPhoto.title': 'Chýbajúca fotka',
	'missingPhoto.description': 'Zdá sa, že chýba fotka. Pre pokračovanie pridajte chýbajúcu fotku. ',
};

export default messages;
